var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.776,
    height: 19.529,
    viewBox: "0 0 17.776 19.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#828282;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.759,5.629A2.629,2.629,0,1,1,25.129,3,2.629,2.629,0,0,1,27.759,5.629Z",
    transform: "translate(-11.983 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.759,16.129A2.629,2.629,0,1,1,7.129,13.5,2.629,2.629,0,0,1,9.759,16.129Z",
    transform: "translate(-4.5 -7.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.759,26.629A2.629,2.629,0,1,1,25.129,24,2.629,2.629,0,0,1,27.759,26.629Z",
    transform: "translate(-11.983 -11.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.885,20.265l5.986,3.488",
    transform: "translate(-7.986 -10.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.862,9.765l-5.977,3.488",
    transform: "translate(-7.986 -5.812)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.ca31be3f29ab47865decea80ca447536.svg";
export { ForwardRef as ReactComponent };